import type { Deactivation2Config } from '@elfsight/widget-deactivation';
import { Deactivation2 } from '@elfsight/widget-deactivation';
import { useSettings } from '@wu/widget-core';
import { meta } from '../../constants';

const { alias } = meta;

type DeactivationProps = Omit<
  Deactivation2Config,
  'appAlias' | 'deactivationURL'
>;

export function Deactivation({
  children,
  displayDeactivation,
  ...forwardingProps
}: DeactivationProps) {
  const { displayDeactivation: settingsDisplayDeactivation, deactivationURL } =
    useSettings();

  return (
    <Deactivation2
      {...forwardingProps}
      appAlias={alias}
      displayDeactivation={displayDeactivation ?? settingsDisplayDeactivation}
      deactivationURL={deactivationURL}
    >
      {children}
    </Deactivation2>
  );
}
